import { useRef } from 'react';

export const useSuspendableValue = <T>(currentValue: T, isSuspended: boolean) => {
  const valueRef = useRef<T>(currentValue);
  if (!isSuspended) {
    valueRef.current = currentValue;
  }

  return isSuspended ? valueRef.current : currentValue;
};
